import MapLayout from "./-components/control/MapLayout";
import Map from "./-components/control/Map";

export default function ConsoleMap() {
    return (
        <MapLayout>
            <Map />
        </MapLayout>
    );
}
